import React from 'react';
import _ from 'lodash';
import ArticleLink from '../ArticleLink.jsx';

export default class FeedContainerText extends React.PureComponent {
  render() {
    const { contentContainers, limit } = this.props;
    const articles = _.slice(contentContainers, 0, limit);

    return (
      <div className="feed-container feed-container-text">
        <ul>
          {
            articles.map(article => {
              return (
                <li key={article.slug}>
                  <ArticleLink contentContainer={article}>
                    <div className="item-indicator"></div>
                    <p>{article.newsFeedTitle || article.title}</p>
                  </ArticleLink>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  }
}

FeedContainerText.propTypes = {
  limit: React.PropTypes.number,
  contentContainers: React.PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedContainerText.jsx